export default "__VITE_ASSET__BXB1MsBu__"